<div class="custom-box" *ngIf="isDataAvailable()">
  <div class="blue-theme" *ngIf="color === 'pur'">
    <div class="">
      <div class="col-xs-9 col-md-9 col-lg-9 International-traveller-section">
        <div class="col-xs-5 col-md-5 col-lg-4 card">
          <div *ngIf="flag === 'Hi'">
            <div *ngFor="let guideTraveller of guideList; let i = index">
              <div class="heading-text" *ngIf="i == 0">{{ guideTraveller.titleHi }}</div>
            </div>
          </div>
          <div *ngIf="flag === 'En'">
            <!---heading-->
            <div *ngFor="let guideTraveller of guideList; let i = index">
              <div class="heading-text" *ngIf="i == 0">{{ guideTraveller.titleEn }}</div>
            </div>
            <!---/heading-->
          </div>
          <ul *ngFor="let guideTravellerData of guideList" class="traveller-data">
            <li *ngFor="let pdflist of PdfDataList">
              <span
                *ngIf="guideTravellerData.id === pdflist.content?.id && pdflist.docTitleEn !== null && pdflist.filePathEn === null">
                {{ pdflist.docTitleEn }}&nbsp;
              </span>
              <span
                *ngIf="guideTravellerData.id === pdflist.content?.id && pdflist.docTitleHi !== null && pdflist.filePathHi === null">
                {{ pdflist.docTitleEn }}&nbsp;
              </span>

              <span
                *ngIf="guideTravellerData.id === pdflist.content?.id && pdflist.docTitleEn == null && pdflist.filePathEn == null">
                <a [routerLink]="" (click)="ViewPdf(pdflist.filePathEn)">
                  {{ pdflist.docTitleEn }}&nbsp;<i *ngIf="pdflist.docType === 'pdf'" class="pdf-icon"
                    aria-hidden="true"></i>
                  <i *ngIf="pdflist.docType === 'xls' || pdflist.docType === 'xlsx' || pdflist.docType === 'xlsb'"
                    class="xls-icon" aria-hidden="true"></i>
                  <i *ngIf="pdflist.docType === 'link'" class="">click here</i>
                </a>
              </span>
              <span
                *ngIf="guideTravellerData.id === pdflist.content?.id && pdflist.docTitleHi == null && pdflist.filePathHi == null">
                <a [routerLink]="" (click)="ViewPdf(pdflist.filePathEn)">
                  {{ pdflist.docTitleEn }}&nbsp;<i *ngIf="pdflist.docType === 'pdf'" class="pdf-icon"
                    aria-hidden="true"></i>
                  <i *ngIf="pdflist.docType === 'xls' || pdflist.docType === 'xlsx' || pdflist.docType === 'xlsb'"
                    class="xls-icon" aria-hidden="true"></i>
                  <i *ngIf="pdflist.docType === 'link'" class="">click here</i>
                </a>
              </span>
            </li>
          </ul>
          <div class="travel-image">
            <img src="content/images/location.svg" alt="traveller" class="float-end img-fluid"
              style="width: 167px; height: 116px; margin-right: 15px" />
          </div>
        </div>
        <div class="col-xs-12 col-md-12 col-lg-4 card">
          <!-- <span class="heading-text">Buggage Rules</span>  -->
          <div *ngIf="flag === 'Hi'">
            <div *ngFor="let buggages of buggageRules; let i = index">
              <div class="heading-text" *ngIf="i == 0">{{ buggages.titleHi }}</div>
            </div>
          </div>
          <div *ngIf="flag === 'En'">
            <div *ngFor="let buggages of buggageRules; let i = index">
              <div class="heading-text" *ngIf="i == 0">{{ buggages.titleEn }}</div>
            </div>
          </div>
          <ul *ngFor="let buggage of buggageRules" class="traveller-data">
            <li *ngFor="let baggerPdf of PdfDataListbagger">
              <span
                *ngIf="buggage.id === baggerPdf.content?.id && baggerPdf.docTitleEn !== null && baggerPdf.filePathEn === null">
                {{ baggerPdf.docTitleEn }}&nbsp;
              </span>
              <span
                *ngIf="buggage.id === baggerPdf.content?.id && baggerPdf.docTitleHi === null && baggerPdf.filePathHi === null">
                {{ baggerPdf.docTitleEn }}&nbsp;
              </span>

              <span
                *ngIf="buggage.id === baggerPdf.content?.id && baggerPdf.docTitleEn !== null && baggerPdf.filePathEn !== null">
                <a [routerLink]="" (click)="ViewPdf(baggerPdf.filePathEn)">
                  {{ baggerPdf.docTitleEn }}&nbsp;<i *ngIf="baggerPdf.docType === 'pdf'" class="pdf-icon"
                    aria-hidden="true"></i>
                  <i *ngIf="baggerPdf.docType === 'xls' || baggerPdf.docType === 'xlsx' || baggerPdf.docType === 'xlsb'"
                    class="xls-icon" aria-hidden="true"></i>
                  <i *ngIf="baggerPdf.docType === 'link'" class="">click here</i>
                </a>
              </span>
              <span
                *ngIf="buggage.id === baggerPdf.content?.id && baggerPdf.docTitleHi === null && baggerPdf.filePathHi === null">
                <a [routerLink]="" (click)="ViewPdf(baggerPdf.filePathEn)">
                  {{ baggerPdf.docTitleEn }}&nbsp;<i *ngIf="baggerPdf.docType === 'pdf'" class="pdf-icon"
                    aria-hidden="true"></i>
                  <i *ngIf="baggerPdf.docType === 'xls' || baggerPdf.docType === 'xlsx' || baggerPdf.docType === 'xlsb'"
                    class="xls-icon" aria-hidden="true"></i>
                  <i *ngIf="baggerPdf.docType === 'link'" class="">click here</i>
                </a>
              </span>
            </li>
          </ul>

          <div class="travel-image">
            <img src="content/images/traveller.svg" alt="traveller" class="float-end img-fluid"
              style="width: 167px; margin-right: 15px" />
          </div>
        </div>
        <div class="col-xs-12 col-md-12 col-lg-4 card">
          <!-- <span class="heading-text">Others</span> -->
          <div *ngIf="flag === 'Hi'">
            <div *ngFor="let othersTitle of othersList; let i = index">
              <div class="heading-text" *ngIf="i == 0">{{ othersTitle.titleHi }}</div>
            </div>
          </div>

          <div *ngIf="flag === 'En'">
            <div *ngFor="let othersTitle of othersList; let i = index">
              <div class="heading-text" *ngIf="i == 0">{{ othersTitle.titleEn }}</div>
            </div>
          </div>
          <ul class="traveller-data others-data">
            <li *ngFor="let othersListData of othersList">
              <span *ngFor="let PdfDataList of PdfDataListOther">
                <span *ngIf="
                    othersListData.id === PdfDataList.content?.id && PdfDataList.docTitleEn !== null && PdfDataList.filePathEn === null
                  ">
                  <span>{{ PdfDataList.docTitleEn }}</span>
                </span>
                <span *ngIf="
                    othersListData.id === PdfDataList.content?.id && PdfDataList.docTitleHi === null && PdfDataList.filePathEn === null
                  ">
                  {{ PdfDataList.docTitleEn }}
                </span>

                <span *ngIf="
                    othersListData.id === PdfDataList.content?.id && PdfDataList.docTitleEn !== null && PdfDataList.filePathEn !== null
                  ">
                  <a [routerLink]="" (click)="ViewPdf(PdfDataList.filePathEn)">
                    {{ PdfDataList.docTitleEn }}&nbsp;<i *ngIf="PdfDataList.docType === 'pdf'" class="pdf-icon"
                      aria-hidden="true"></i>
                    <i *ngIf="PdfDataList.docType === 'xls' || PdfDataList.docType === 'xlsx' || PdfDataList.docType === 'xlsb'"
                      class="xls-icon" aria-hidden="true"></i>
                    <i *ngIf="PdfDataList.docType === 'link'" class="">click here</i>
                  </a>
                </span>
                <span *ngIf="
                    othersListData.id === PdfDataList.content?.id && PdfDataList.docTitleHi === null && PdfDataList.filePathHi === null
                  ">
                  <a [routerLink]="" (click)="ViewPdf(PdfDataList.filePathEn)">
                    {{ PdfDataList.docTitleEn }}&nbsp;<i *ngIf="PdfDataList.docType === 'pdf'" class="pdf-icon"
                      aria-hidden="true"></i>
                    <i *ngIf="PdfDataList.docType === 'xls' || PdfDataList.docType === 'xlsx' || PdfDataList.docType === 'xlsb'"
                      class="xls-icon" aria-hidden="true"></i>
                    <i *ngIf="PdfDataList.docType === 'link'" class="">click here</i>
                  </a>
                </span>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-lg-12 International-traveller-section mt10 align_bottom">
        <div class="col-12 card" style="width: 95.8%;">
          <div class="heading-text text-center fw-bold">Athithi@Indian Customs</div>
          <h6 class="fw-bold">Customs Mobile Application for International Travelers</h6>
          <small>ATITHI @Indian Customs. It is developed by Directorate General of Systems, Central Board of Indirect
            Taxes(CBIC), Department of
            Revenue, Ministry of Finance, Government of India to drive digital Governance in India. This application
            provides a platform for
            all visitors travelling to India globally to file their baggage, Item & Currency declarations and other
            citizen centric
            services. It will reduce the time taken for Customs Declaration and will ease the arrival process at Indian
            Airports.
            ATITHI@Indian Customs has been made available on Android and iOS platforms.</small>
          <ul class="noMargin noPadding app-store-link">
            <li class="float-start">
              <a href="https://play.google.com/store/apps/details?id=com.org.customnew&amp;hl=en_IN&amp;gl=US"
                target="_blank">Android <i class="icon-android-os"></i></a>
            </li>
            <li></li>
            <li class="float-start">
              <a href="https://apps.apple.com/lu/app/atithi-indian-customs/id1481045693" target="_blank">Apple
                <i class="icon-apple-logo"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <!--- <a href="#" class="float-end col-lg-1 text-decoration-none see-more">
            View More
        </a>--->
    </div>
  </div>

  <section class="gst-section-black" *ngIf="color === 'bule'">
    <!--first row-->
    <div class="row grid">
      <!--- <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">-->

      <!---first row start here-->
      <div class="col-lg-12 International-traveller-section mb3">
        <div class="col-xs-12 col-md-12 col-lg-6 card">
          <!-- <span class="heading-text">Guide for Travellers</span> -->
          <div *ngIf="flag === 'Hi'">
            <div *ngFor="let guideTraveller of guideList; let i = index">
              <div class="heading-text" *ngIf="i == 0">{{ guideTraveller.titleHi }}</div>
            </div>
          </div>
          <div *ngIf="flag === 'En'">
            <div *ngFor="let guideTraveller of guideList; let i = index">
              <div class="heading-text" *ngIf="i == 0">{{ guideTraveller.titleEn }}</div>
            </div>
          </div>
          <div *ngFor="let guideTravellerData of guideList">
            <span *ngFor="let pdflist of PdfDataList">
              <span
                *ngIf="guideTravellerData.id === pdflist.content?.id && pdflist.docTitleEn !== null && pdflist.filePathEn === null">
                {{ pdflist.docTitleEn }}&nbsp;
              </span>
              <span
                *ngIf="guideTravellerData.id === pdflist.content?.id && pdflist.docTitleHi === null && pdflist.filePathHi === null">
                {{ pdflist.docTitleEn }}&nbsp;
              </span>

              <span
                *ngIf="guideTravellerData.id === pdflist.content?.id && pdflist.docTitleEn !== null && pdflist.filePathEn !== null">
                <a [routerLink]="" (click)="ViewPdf(pdflist.filePathEn)">
                  {{ pdflist.docTitleEn }}&nbsp;<i *ngIf="pdflist.docType === 'pdf'" class="pdf-icon"
                    aria-hidden="true"></i>
                  <i *ngIf="pdflist.docType === 'xls' || pdflist.docType === 'xlsx' || pdflist.docType === 'xlsb'"
                    class="xls-icon" aria-hidden="true"></i>
                  <i *ngIf="pdflist.docType === 'link'" class="">click here</i>
                </a>
              </span>
              <span
                *ngIf="guideTravellerData.id === pdflist.content?.id && pdflist.docTitleHi === null && pdflist.filePathEn !== null">
                <a [routerLink]="" (click)="ViewPdf(pdflist.filePathEn)">
                  {{ pdflist.docTitleEn }}&nbsp;<i *ngIf="pdflist.docType === 'pdf'" class="pdf-icon"
                    aria-hidden="true"></i>
                  <i *ngIf="pdflist.docType === 'xls' || pdflist.docType === 'xlsx' || pdflist.docType === 'xlsb'"
                    class="xls-icon" aria-hidden="true"></i>
                  <i *ngIf="pdflist.docType === 'link'" class="">click here</i>
                </a>
              </span>
            </span>
          </div>
          <div class="col-xs-12 col-md-6 col-lg-6 card">
            <!-- <span class="heading-text">Buggage Rules</span>  -->
            <div *ngIf="flag === 'Hi'">
              <div *ngFor="let buggages of buggageRules; let i = index">
                <div class="heading-text" *ngIf="i == 0">{{ buggages.titleHi }}</div>
              </div>
            </div>
            <div *ngIf="flag === 'En'">
              <div *ngFor="let buggages of buggageRules; let i = index">
                <div class="heading-text" *ngIf="i == 0">{{ buggages.titleEn }}</div>
              </div>
            </div>

            <div *ngFor="let buggage of buggageRules">
              <span *ngFor="let baggerPdf of PdfDataListbagger">
                <span
                  *ngIf="buggage.id === baggerPdf.content?.id && baggerPdf.docTitleEn !== null && baggerPdf.filePathEn === null">
                  {{ baggerPdf.docTitleEn }}&nbsp;
                </span>
                <span
                  *ngIf="buggage.id === baggerPdf.content?.id && baggerPdf.docTitleHi === null && baggerPdf.filePathHi === null">
                  {{ baggerPdf.docTitleEn }}&nbsp;
                </span>

                <span
                  *ngIf="buggage.id === baggerPdf.content?.id && baggerPdf.docTitleEn !== null && baggerPdf.filePathEn !== null">
                  <a [routerLink]="" (click)="ViewPdf(baggerPdf.filePathEn)">
                    {{ baggerPdf.docTitleEn }}&nbsp;<i *ngIf="baggerPdf.docType === 'pdf'" class="pdf-icon"
                      aria-hidden="true"></i>
                    <i *ngIf="baggerPdf.docType === 'xls' || baggerPdf.docType === 'xlsx' || baggerPdf.docType === 'xlsb'"
                      class="xls-icon" aria-hidden="true"></i>
                    <i *ngIf="baggerPdf.docType === 'link'" class="">click here</i>
                  </a>
                </span>
                <span
                  *ngIf="buggage.id === baggerPdf.content?.id && baggerPdf.docTitleHi === null && baggerPdf.filePathHi === null">
                  <a [routerLink]="" (click)="ViewPdf(baggerPdf.filePathEn)">
                    {{ baggerPdf.docTitleEn }}&nbsp;<i *ngIf="baggerPdf.docType === 'pdf'" class="pdf-icon"
                      aria-hidden="true"></i>
                    <i *ngIf="baggerPdf.docType === 'xls' || baggerPdf.docType === 'xlsx' || baggerPdf.docType === 'xlsb'"
                      class="xls-icon" aria-hidden="true"></i>
                    <i *ngIf="baggerPdf.docType === 'link'" class="">click here</i>
                  </a>
                </span>
              </span>
            </div>
          </div>

          <!-- new -->
          <div class="col-xs-12 col-md-6 col-lg-6 card">
            <!-- <span class="heading-text">Buggage Rules</span>  -->
            <div *ngIf="flag === 'Hi'">
              <div *ngFor="let buggages of buggageRules; let i = index">
                <div class="heading-text" *ngIf="i == 0">{{ buggages.titleHi }}</div>
              </div>
            </div>
            <div *ngIf="flag === 'En'">
              <div *ngFor="let buggages of buggageRules; let i = index">
                <div class="heading-text" *ngIf="i == 0">{{ buggages.titleEn }}</div>
              </div>
            </div>

            <div *ngFor="let buggage of buggageRules">
              <span *ngFor="let baggerPdf of PdfDataListbagger">
                <span
                  *ngIf="buggage.id === baggerPdf.content?.id && baggerPdf.docTitleEn !== null && baggerPdf.filePathEn === null">
                  {{ baggerPdf.docTitleEn }}&nbsp;
                </span>
                <span
                  *ngIf="buggage.id === baggerPdf.content?.id && baggerPdf.docTitleHi === null && baggerPdf.filePathHi === null">
                  {{ baggerPdf.docTitleEn }}&nbsp;
                </span>

                <span
                  *ngIf="buggage.id === baggerPdf.content?.id && baggerPdf.docTitleEn !== null && baggerPdf.filePathEn !== null">
                  <a [routerLink]="" (click)="ViewPdf(baggerPdf.filePathEn)">
                    {{ baggerPdf.docTitleEn }}&nbsp;<i *ngIf="baggerPdf.docType === 'pdf'" class="pdf-icon"
                      aria-hidden="true"></i>
                    <i *ngIf="baggerPdf.docType === 'xls' || baggerPdf.docType === 'xlsx' || baggerPdf.docType === 'xlsb'"
                      class="xls-icon" aria-hidden="true"></i>
                    <i *ngIf="baggerPdf.docType === 'link'" class="">click here</i>
                  </a>
                </span>
                <span
                  *ngIf="buggage.id === baggerPdf.content?.id && baggerPdf.docTitleHi === null && baggerPdf.filePathHi === null">
                  <a [routerLink]="" (click)="ViewPdf(baggerPdf.filePathEn)">
                    {{ baggerPdf.docTitleEn }}&nbsp;<i *ngIf="baggerPdf.docType === 'pdf'" class="pdf-icon"
                      aria-hidden="true"></i>
                    <i *ngIf="baggerPdf.docType === 'xls' || baggerPdf.docType === 'xlsx' || baggerPdf.docType === 'xlsb'"
                      class="xls-icon" aria-hidden="true"></i>
                    <i *ngIf="baggerPdf.docType === 'link'" class="">click here</i>
                  </a>
                </span>
              </span>
            </div>
          </div>
        </div>


     
        <!---first row ends here-->
        <!---second row start-->
        <div class="col-lg-11 International-traveller-section">
          <div class="col-xs-12 col-md-12 col-lg-6 card">
            <!-- <span class="heading-text">Atithi @Indian Customs</span> -->
            <div *ngIf="flag === 'Hi'">
              <div *ngFor="let atitthiTitle of atitthiDataList; let i = index">
                <div class="heading-text" *ngIf="i == 0">{{ atitthiTitle.titleHi }}</div>
              </div>
            </div>
            <div *ngIf="flag === 'En'">
              <div *ngFor="let atitthiTitle of atitthiDataList; let i = index">
                <div class="heading-text" *ngIf="i == 0">{{ atitthiTitle.titleEn }}</div>
              </div>
            </div>
            <div *ngFor="let atitthiData of atitthiDataList">
              <a href="{{ atitthiData.path }}" target="_blank"><img src="content/images/Atithi.svg" alt="traveller"
                  class="float-end img-fluid" /></a>
            </div>
          </div>

          <div class="col-xs-12 col-md-12 col-lg-6 card">
            <!-- <span class="heading-text">Others</span> -->
            <div *ngIf="flag === 'Hi'">
              <div *ngFor="let othersTitle of othersList; let i = index">
                <div class="heading-text" *ngIf="i == 0">{{ othersTitle.titleHi }}</div>
              </div>
            </div>
            <div *ngIf="flag === 'En'">
              <div *ngFor="let othersTitle of othersList; let i = index">
                <div class="heading-text" *ngIf="i == 0">{{ othersTitle.titleEn }}</div>
              </div>
            </div>
            <div *ngFor="let othersListData of othersList">
              <span *ngFor="let PdfDataList of PdfDataListOther">
                <span *ngIf="
                    othersListData.id === PdfDataList.content?.id && PdfDataList.docTitleEn !== null && PdfDataList.filePathEn === null
                  ">
                  {{ PdfDataList.docTitleEn }}&nbsp;
                </span>
                <span *ngIf="
                    othersListData.id === PdfDataList.content?.id && PdfDataList.docTitleHi === null && PdfDataList.filePathHi === null
                  ">
                  {{ PdfDataList.docTitleEn }}&nbsp;
                </span>

                <span *ngIf="
                    othersListData.id === PdfDataList.content?.id && PdfDataList.docTitleEn !== null && PdfDataList.filePathEn !== null
                  ">
                  <a [routerLink]="" (click)="ViewPdf(PdfDataList.filePathEn)">
                    {{ PdfDataList.docTitleEn }}&nbsp;<i *ngIf="PdfDataList.docType === 'pdf'" class="pdf-icon"
                      aria-hidden="true"></i>
                    <i *ngIf="PdfDataList.docType === 'xls' || PdfDataList.docType === 'xlsx' || PdfDataList.docType === 'xlsb'"
                      class="xls-icon" aria-hidden="true"></i>
                    <i *ngIf="PdfDataList.docType === 'link'" class="">click here</i>
                  </a>
                </span>
                <span *ngIf="
                    othersListData.id === PdfDataList.content?.id && PdfDataList.docTitleHi === null && PdfDataList.filePathHi === null
                  ">
                  <a [routerLink]="" (click)="ViewPdf(PdfDataList.filePathEn)">
                    {{ PdfDataList.docTitleEn }}&nbsp;<i *ngIf="PdfDataList.docType === 'pdf'" class="pdf-icon"
                      aria-hidden="true"></i>
                    <i *ngIf="PdfDataList.docType === 'xls' || PdfDataList.docType === 'xlsx' || PdfDataList.docType === 'xlsb'"
                      class="xls-icon" aria-hidden="true"></i>
                    <i *ngIf="PdfDataList.docType === 'link'" class="">click here</i>
                  </a>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <!--- <a href="#" class="float-end col-lg-1 text-decoration-none see-more">
            View More
        </a>--->
      <!-- </section> -->
    </div>
  </section>
</div>